import { createIcon } from '@chakra-ui/react';

export const CardIcon = createIcon({
  displayName: 'CardIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M2.61987 10.5858L10.5865 2.61914"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.40088 12.1867L8.20088 11.3867"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.19531 10.3922L10.7886 8.79883"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.40077 6.82567L6.82743 2.39901C8.24077 0.985675 8.94743 0.979008 10.3474 2.37901L13.6208 5.65234C15.0208 7.05234 15.0141 7.75901 13.6008 9.17234L9.1741 13.599C7.76077 15.0123 7.0541 15.019 5.6541 13.619L2.38077 10.3457C0.980765 8.94568 0.980765 8.24567 2.40077 6.82567Z"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.33325 14.666H14.6666"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
